export type PersonType = {
  readonly MYBOX_VIDA_CARE: 0
  readonly ANNUITY: 1
}

export const PERSON_TYPE: PersonType = Object.freeze({
  MYBOX_VIDA_CARE: 0,
  ANNUITY: 1,
})
